module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABBklEQVRYR+2VsRHCIBSGH9QpMkLKHFC4gTqJuoEjOIIbGDdwBFfw7kFSuoEuEPDIyV0uhQRS2DwaivD4Pn54FwZ/HuzPfCABSoASWJSAlPLIGCsR8ZTbzosElFJ3D0bEDQlQApRASKCu66rruufcRGa3YVVVZVEUL2vtwRjTeMC0DYUQe875BQC2iDi0aGzMFvAbSSkbxtguSIwFAtw5d9Va72Pg8D1JYCrBOR9A1trGnzwV7muTBcYSAPD+nqTMgWcLTCQgF75IwBcLIc5+NsYc5975dF30CpRS/kezzgH0ff9o2/b2qzYqEF5+joBz7qG1Xi0SyAGn1EQTSNksZy0JUAKUwAc3Ln4h7Ns0TwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/download.png
// module id = KHQS
// module chunks = 1